/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/file_png'
export default icon
